import { Pipe, PipeTransform } from '@angular/core';
import { stripAndTrim } from '../../../utils/string.utils';

@Pipe({
    standalone: true,
    name: 'stripAndTrim',
})
export class StripAndTrimPipe implements PipeTransform {

    public transform(text: any, length: number = 30) {
        return stripAndTrim(String(text || ''), length);
    }

}
